var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4.66602C9.7868 4.66602 4.75 9.70281 4.75 15.916C4.75 22.1292 9.7868 27.166 16 27.166C22.2132 27.166 27.25 22.1292 27.25 15.916C27.25 9.70281 22.2132 4.66602 16 4.66602ZM3.25 15.916C3.25 8.87438 8.95837 3.16602 16 3.16602C23.0416 3.16602 28.75 8.87438 28.75 15.916C28.75 22.9576 23.0416 28.666 16 28.666C8.95837 28.666 3.25 22.9576 3.25 15.916ZM16.5303 10.3857L20.5303 14.3857C20.8232 14.6786 20.8232 15.1535 20.5303 15.4463C20.2374 15.7392 19.7626 15.7392 19.4697 15.4463L16.9207 12.8974C16.8577 12.8344 16.75 12.879 16.75 12.9681L16.75 21.2493C16.75 21.6636 16.4142 21.9993 16 21.9993C15.5858 21.9993 15.25 21.6636 15.25 21.2493L15.25 12.9681C15.25 12.879 15.1423 12.8344 15.0793 12.8974L12.5303 15.4463C12.2374 15.7392 11.7626 15.7392 11.4697 15.4463C11.1768 15.1535 11.1768 14.6786 11.4697 14.3857L15.4697 10.3857C15.7626 10.0928 16.2374 10.0928 16.5303 10.3857Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpCircle);
export default __webpack_public_path__ + "static/media/arrow-up-circle.2ae6c2c8cdb51e0a96ce261c565975e4.svg";
export { ForwardRef as ReactComponent };